<template>
    <div class="div-box" @click="jump">
        用户中心
    </div>
</template>

<script>
export default {
  methods: {
    jump () {
      // this.$router.push('/Project/UserManagement')
      window.parent.location.href = '/web/userCenter/#/Project/UserManagement'
    }
  }
}
</script>
<style scoped>
  .div-box {
    width: 300px;
    height: 150px;
    font-size: 16px;
    line-height: 150px;
    text-align: center;
    cursor: pointer;
  }
</style>

<style lang="scss" scoped>

</style>
